// Portuguese labels and formatting for the planner, as in the Android app (Models/*Labels).
import * as T from './types';

const LOCALE = 'pt-PT';

export const SECTIONS: { value: T.StoreSection; text: string }[] = [
  { value: 'FruitAndVegetables', text: 'Frutas e legumes' },
  { value: 'Butcher', text: 'Talho' },
  { value: 'Fishmonger', text: 'Peixaria' },
  { value: 'DeliAndCheese', text: 'Charcutaria e queijos' },
  { value: 'DairyAndEggs', text: 'Laticínios e ovos' },
  { value: 'Bakery', text: 'Padaria' },
  { value: 'Grocery', text: 'Mercearia' },
  { value: 'Frozen', text: 'Congelados' },
  { value: 'Drinks', text: 'Bebidas' },
  { value: 'Household', text: 'Limpeza e casa' },
  { value: 'Other', text: 'Outros' },
];

export const UNITS: { value: T.MeasureUnit; text: string; short: string }[] = [
  { value: 'Unit', text: 'Unidade', short: 'un' },
  { value: 'Gram', text: 'Grama', short: 'g' },
  { value: 'Kilogram', text: 'Quilograma', short: 'kg' },
  { value: 'Millilitre', text: 'Mililitro', short: 'ml' },
  { value: 'Litre', text: 'Litro', short: 'l' },
  { value: 'Tablespoon', text: 'Colher de sopa', short: 'c. sopa' },
  { value: 'Teaspoon', text: 'Colher de chá', short: 'c. chá' },
  { value: 'Clove', text: 'Dente', short: 'dente' },
  { value: 'Pinch', text: 'Pitada', short: 'pitada' },
  { value: 'Package', text: 'Embalagem', short: 'emb.' },
  { value: 'Can', text: 'Lata', short: 'lata' },
];

export const TAGS: { value: T.RecipeTag; text: string }[] = [
  { value: 'Fish', text: 'Peixe' },
  { value: 'Meat', text: 'Carne' },
  { value: 'RedMeat', text: 'Carne vermelha' },
  { value: 'Poultry', text: 'Aves' },
  { value: 'Vegetarian', text: 'Vegetariano' },
  { value: 'Pasta', text: 'Massa' },
  { value: 'Soup', text: 'Sopa' },
  { value: 'Weekend', text: 'Fim de semana' },
  { value: 'Kids', text: 'Miúdos' },
];

export const MEAL_COURSES: { value: T.MealCourse; text: string; add: string }[] = [
  { value: 'Starter', text: 'Entrada', add: 'Entrada' },
  { value: 'Main', text: 'Outro prato', add: 'Outro prato' },
  { value: 'Dessert', text: 'Sobremesa', add: 'Sobremesa' },
];

export const MEAL_KINDS: { value: T.MealSlotKind; text: string }[] = [
  { value: 'Empty', text: 'Por definir' },
  { value: 'Recipe', text: 'Receita' },
  { value: 'Leftovers', text: 'Sobras' },
  { value: 'FreeText', text: 'Outra coisa' },
  { value: 'Out', text: 'Fora' },
  { value: 'Frozen', text: 'Do congelador' },
];

export const TASK_CATEGORIES: { value: T.TaskCategory; text: string }[] = [
  { value: 'Home', text: 'Casa' },
  { value: 'Kids', text: 'Filhos' },
  { value: 'Admin', text: 'Administrativo' },
  { value: 'Car', text: 'Carro' },
  { value: 'Garden', text: 'Jardim' },
  { value: 'Meals', text: 'Refeições' },
  { value: 'Shopping', text: 'Compras' },
  { value: 'Other', text: 'Outros' },
];

export const RECURRENCES: { value: T.RecurrenceType; text: string }[] = [
  { value: 'None', text: 'Não se repete' },
  { value: 'Daily', text: 'Diária / a cada N dias' },
  { value: 'Weekly', text: 'Semanal' },
  { value: 'Monthly', text: 'Mensal' },
  { value: 'FlexibleWeekly', text: 'N vezes por semana (sem dia fixo)' },
];

export const TASK_ALERTS: { value: T.TaskAlert; text: string }[] = [
  { value: 'Notification', text: 'Notificação' },
  { value: 'Alarm', text: 'Alarme' },
  { value: 'None', text: 'Sem aviso' },
];

/** How long before the due time the phone warns. */
export const ALERT_TIMES: { minutes: number; text: string }[] = [
  { minutes: 0, text: 'À hora' },
  { minutes: 5, text: '5 min antes' },
  { minutes: 15, text: '15 min antes' },
  { minutes: 30, text: '30 min antes' },
  { minutes: 60, text: '1 h antes' },
];

export const RECURRING_FREQUENCIES: { value: T.RecurringFrequency; text: string }[] = [
  { value: 'Weekly', text: 'Todas as semanas' },
  { value: 'Biweekly', text: 'De 15 em 15 dias' },
  { value: 'Monthly', text: 'Todos os meses' },
];

/** Monday first. */
export const THEMES: { value: T.ThemePreference; text: string }[] = [
  { value: 'System', text: 'Como o browser' },
  { value: 'Light', text: 'Claro' },
  { value: 'Dark', text: 'Escuro' },
];

/** The start screens, the same list as on Android, with the page each one opens here. */
export const START_SCREENS: { value: T.StartScreen; text: string; path: string }[] = [
  { value: 'Week', text: 'Semana', path: '/casa/semana' },
  { value: 'Tasks', text: 'Tarefas', path: '/casa/tarefas' },
  { value: 'MealPlan', text: 'Plano das refeições', path: '/casa/refeicoes' },
  { value: 'Shopping', text: 'Lista das compras', path: '/casa/compras' },
  { value: 'Stock', text: 'Em casa', path: '/casa/em-casa' },
  { value: 'Expenses', text: 'Despesas', path: '/expenses' },
];

export const EXPENSE_KINDS: { value: T.ExpenseKind; text: string }[] = [
  { value: 'Home', text: 'Da casa' },
  { value: 'Personal', text: 'Pessoais' },
];

export const startPath = (screen?: T.StartScreen | null) =>
  START_SCREENS.find(s => s.value === screen)?.path ?? START_SCREENS[0].path;

export const WEEK_DAYS: T.DayOfWeek[] = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
const DAY_NAMES: Record<T.DayOfWeek, string> = {
  Monday: 'Segunda-feira', Tuesday: 'Terça-feira', Wednesday: 'Quarta-feira', Thursday: 'Quinta-feira',
  Friday: 'Sexta-feira', Saturday: 'Sábado', Sunday: 'Domingo',
};
const DAY_SHORT: Record<T.DayOfWeek, string> = {
  Monday: 'Seg', Tuesday: 'Ter', Wednesday: 'Qua', Thursday: 'Qui', Friday: 'Sex', Saturday: 'Sáb', Sunday: 'Dom',
};
export const dayName = (day: T.DayOfWeek) => DAY_NAMES[day];
export const shortDay = (day: T.DayOfWeek) => DAY_SHORT[day];

/** Avatar colours offered when editing a member; also the fallback palette. */
export const MEMBER_PALETTE = ['#1976D2', '#E53935', '#43A047', '#FB8C00', '#8E24AA', '#00897B', '#F4511E', '#6D4C41'];
export const ADULT_WEIGHT = 1;
export const CHILD_WEIGHT = 0.5;

export const sectionText = (value: T.StoreSection) => SECTIONS.find(s => s.value === value)?.text ?? value;
export const unitShort = (value: T.MeasureUnit) => UNITS.find(u => u.value === value)?.short ?? value;
export const tagText = (value: T.RecipeTag) => TAGS.find(t => t.value === value)?.text ?? value;
export const frequencyText = (value: T.RecipeFrequency) => (value === 'Habitual' ? 'Habitual' : 'Ocasional');
export const mealText = (type: T.MealType) => (type === 'Lunch' ? 'Almoço' : 'Jantar');
export const mealCourseText = (course: T.MealCourse) => MEAL_COURSES.find(c => c.value === course)?.text ?? course;
export const categoryText = (value: T.TaskCategory) => TASK_CATEGORIES.find(c => c.value === value)?.text ?? value;
export const recurringFrequencyText = (value: T.RecurringFrequency) => RECURRING_FREQUENCIES.find(f => f.value === value)?.text ?? value;

// ---------- Numbers ----------

export const number = (value: number, maxDecimals = 3) =>
  value.toLocaleString(LOCALE, { maximumFractionDigits: maxDecimals });

export const money = (value: number) =>
  value.toLocaleString(LOCALE, { style: 'currency', currency: 'EUR' });

/** "0,5 kg × 2,30 €/kg"; with only the label total entered, the price per kg comes from it. */
export const weighedPrice = (weight: number, pricePerKg: number | null | undefined, lineTotal: number) =>
  `${number(weight)} kg × ${money(pricePerKg ?? Math.round(lineTotal / weight * 100) / 100)}/kg`;

/** "300 g", "2", or empty when there is no quantity. */
export function quantity(value?: number | null, unit?: T.MeasureUnit | null): string {
  if (value === null || value === undefined) return '';
  return unit ? `${number(value)} ${unitShort(unit)}` : number(value);
}

/** "300 g", "300 g + q.b.", "q.b." or empty. */
export function amount(value: number | null | undefined, unit: T.MeasureUnit | null | undefined, hasUnquantified: boolean): string {
  const text = quantity(value, unit);
  if (!hasUnquantified) return text;
  return text.length === 0 ? 'q.b.' : `${text} + q.b.`;
}

export const servings = (value: number) => (value === 1 ? '1 dose' : `${number(value, 2)} doses`);

export function portionText(weight: number): string {
  if (weight === ADULT_WEIGHT) return 'Adulto · 1 dose';
  if (weight === CHILD_WEIGHT) return 'Criança · ½ dose';
  return `${number(weight, 2)} dose`;
}

export function leadTime(minutes: number): string {
  const day = 24 * 60;
  if (minutes % day === 0) return minutes / day === 1 ? '1 dia antes' : `${minutes / day} dias antes`;
  if (minutes % 60 === 0) return `${minutes / 60} h antes`;
  return `${minutes} min antes`;
}

/** Same key as the server's NameNormalizer: lower case, no accents. */
export function searchKey(value?: string | null): string {
  if (!value) return '';
  return value.trim().normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
}

/** Parses "1,5" or "1.5"; empty → null. */
export function parseNumber(text: string): number | null {
  const trimmed = text.trim().replace(',', '.');
  if (trimmed.length === 0) return null;
  const value = Number(trimmed);
  return Number.isFinite(value) ? value : null;
}

// ---------- Dates (DateOnly strings, local time) ----------

const pad = (n: number) => String(n).padStart(2, '0');

const toDateOnly = (date: Date): T.DateOnly => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

function fromDateOnly(value: T.DateOnly): Date {
  const [y, m, d] = value.substring(0, 10).split('-').map(Number);
  return new Date(y, m - 1, d);
}

export const today = (): T.DateOnly => toDateOnly(new Date());

export function addDays(value: T.DateOnly, days: number): T.DateOnly {
  const date = fromDateOnly(value);
  date.setDate(date.getDate() + days);
  return toDateOnly(date);
}

/** Monday of the week containing `value`. */
export function weekStart(value: T.DateOnly): T.DateOnly {
  const date = fromDateOnly(value);
  return addDays(value, -((date.getDay() + 6) % 7));
}

const capitalize = (text: string) => (text.length === 0 ? text : text[0].toLocaleUpperCase(LOCALE) + text.substring(1));

/** "Segunda-feira, 3 nov" (or just the weekday). */
export function dayLabel(value: T.DateOnly, withMonth = true): string {
  const date = fromDateOnly(value);
  const text = withMonth
    ? `${date.toLocaleDateString(LOCALE, { weekday: 'long' })}, ${date.getDate()} ${monthShort(date)}`
    : date.toLocaleDateString(LOCALE, { weekday: 'long' });
  return capitalize(text);
}

/** "Hoje · Segunda-feira, 3 nov". */
export const dayTitle = (value: T.DateOnly) => (value === today() ? 'Hoje · ' : '') + dayLabel(value);

const monthShort = (date: Date) => date.toLocaleDateString(LOCALE, { month: 'short' }).replace('.', '');

/** "3 nov". */
const shortDate = (value: T.DateOnly) => {
  const date = fromDateOnly(value);
  return `${date.getDate()} ${monthShort(date)}`;
};

/** "3 nov" for a UTC timestamp, in local time. The API sends UTC without the "Z". */
export const shortDateTime = (iso: string) => {
  const date = new Date(/(?:[zZ]|[+-]\d\d:\d\d)$/.test(iso) ? iso : `${iso}Z`);
  return `${date.getDate()} ${monthShort(date)}`;
};

/** "hoje", "amanhã" or "sáb 31". */
export function nearDay(value: T.DateOnly): string {
  if (value === today()) return 'hoje';
  if (value === addDays(today(), 1)) return 'amanhã';
  return `${shortDay(dayOfWeekOf(value)).toLowerCase()} ${fromDateOnly(value).getDate()}`;
}

/** "3 a 9 nov" or "29 out a 4 nov". */
export function weekTitle(start: T.DateOnly): string {
  const end = addDays(start, 6);
  const a = fromDateOnly(start);
  const b = fromDateOnly(end);
  return a.getMonth() === b.getMonth() ? `${a.getDate()} a ${shortDate(end)}` : `${shortDate(start)} a ${shortDate(end)}`;
}

/** "seg jantar". */
export function shortMeal(date: T.DateOnly, type: T.MealType): string {
  const day = fromDateOnly(date).toLocaleDateString(LOCALE, { weekday: 'short' }).replace('.', '');
  return `${day} ${mealText(type).toLowerCase()}`;
}

/** The list with `item` added, or without it when it is there. */
export const toggleIn = <V,>(list: V[], item: V): V[] => (list.indexOf(item) >= 0 ? list.filter(x => x !== item) : list.concat(item));

/** The aliases with what is typed but not added yet (once, whatever the case). */
export function withPendingAlias(aliases: string[], pending: string): string[] {
  const text = pending.trim().toLocaleLowerCase();
  return text && !aliases.some(a => a.toLocaleLowerCase() === text) ? aliases.concat(pending.trim()) : aliases;
}

export const dayOfWeekOf = (value: T.DateOnly): T.DayOfWeek =>
  (['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'] as T.DayOfWeek[])[fromDateOnly(value).getDay()];

/** "13:00:00" → "13:00". */
export const time = (value?: T.TimeOnly | null) => (value ? value.substring(0, 5) : '');
/** "13:00" → "13:00:00"; empty → null. */
export const toTimeOnly = (value: string): T.TimeOnly | null => (value ? (value.length === 5 ? `${value}:00` : value) : null);

// ---------- Members ----------

export function initials(name: string): string {
  return name.split(' ').filter(Boolean).slice(0, 2).map(w => w[0].toLocaleUpperCase(LOCALE)).join('');
}

/** Chosen colour, or a stable one picked from the palette by name (same hash as Android). */
export function avatarColor(member: { name: string; color?: string | null }): string {
  if (member.color) return member.color;
  let hash = 0;
  for (let i = 0; i < member.name.length; i++) hash = (Math.imul(hash, 31) + member.name.charCodeAt(i)) | 0;
  return MEMBER_PALETTE[(hash & 0x7fffffff) % MEMBER_PALETTE.length];
}

/** "todos", "ninguém", or the first names of the people. */
export function people(ids: T.Guid[], members: T.HouseholdMember[]): string {
  if (ids.length === 0) return 'ninguém';
  if (members.length > 1 && members.every(m => ids.includes(m.publicId))) return 'todos';
  return members.filter(m => ids.includes(m.publicId)).map(m => m.name.split(' ')[0]).join(', ');
}

// ---------- Meals ----------

export function mealWarning(warning: T.MealSlotWarning): string {
  switch (warning) {
    case 'LeftoversWithoutSource': return 'Sobras de quê? Escolhe a refeição.';
    case 'LeftoversSourceNotRecipe': return 'Sem solução: a refeição anterior não deixa sobras.';
    case 'LeftoversSourceDoesNotKeep': return 'Sem solução: a receita anterior não dá para sobras.';
    case 'NoAttendees': return 'Ninguém come esta refeição.';
    case 'LeftoversSourceNotPlanned': return 'Depende da refeição anterior, ainda por definir.';
    case 'FrozenNotEnough': return 'Não há doses congeladas que cheguem para todas as refeições planeadas.';
    default: return warning;
  }
}

export function slotTitle(slot: T.MealSlot): string {
  switch (slot.kind) {
    case 'Recipe': return slot.dishName ?? slot.recipeName ?? 'Receita';
    case 'Frozen': return slot.dishName ?? 'Do congelador';
    case 'Leftovers': return slot.leftoversFromRecipeName ? `Sobras de ${slot.leftoversFromRecipeName}` : 'Sobras';
    case 'FreeText': return slot.freeText ?? 'Outra coisa';
    case 'Out': return slot.freeText ? `Fora · ${slot.freeText}` : 'Fora';
    default: return '—';
  }
}

export function slotSubtitle(slot: T.MealSlot, members: T.HouseholdMember[]): string {
  const attendees = [people(slot.attendeePublicIds, members), guestsText(slot.guests)].filter(p => p).join(' + ');
  const parts: string[] = [];
  // Servings only matter when there is something to cook or eat
  if (slot.kind !== 'Empty' && slot.kind !== 'Out' && (slot.attendeePublicIds.length > 0 || slot.guests > 0)) {
    parts.push(servings(slot.servings));
    if ((slot.kind === 'Recipe' || slot.kind === 'Frozen') && slot.leftoverConsumerCount > 0) parts.push('inclui sobras');
    if (slot.freezeServings) parts.push(`+${servings(slot.freezeServings)} para congelar`);
  }
  if (attendees) parts.push(attendees);
  const tasks = slot.tasks ?? [];
  if (tasks.length === 1) parts.push(`📋 ${mealTaskText(tasks[0])}`);
  else if (tasks.length > 1) parts.push(`📋 ${tasks.length} tarefas${tasks.every(t => t.status !== 'Pending') ? ' ✔' : ''}`);
  return parts.join(' · ');
}

/** "2 convidados", or empty. */
export const guestsText = (guests: number) => (guests === 0 ? '' : guests === 1 ? '1 convidado' : `${guests} convidados`);

/** "Entrada: sopa de abóbora · Sobremesa: mousse, queijos", or empty. */
export function dishesText(dishes: T.MealDish[]): string {
  return MEAL_COURSES
    .map(c => ({ c, names: dishes.filter(d => d.course === c.value).map(d => d.name) }))
    .filter(x => x.names.length > 0)
    .map(x => `${x.c.text}: ${x.names.join(', ')}`)
    .join(' · ');
}

/** "Ir buscar a comida 19:30 ✔". */
export const mealTaskText = (task: T.MealSlotTask) =>
  [task.title, time(task.dueTime), task.status === 'Done' ? '✔' : task.status === 'Skipped' ? '(dispensada)' : '']
    .filter(Boolean).join(' ');

/** "+ arroz de feijão + salada", or empty. */
export const sidesText = (sides: T.RecipeSide[]) => sides.map(s => ` + ${s.name.toLowerCase()}`).join('');

// ---------- Tasks ----------

/** "Rita" when assigned, "feito por Rita" when done, "quem puder" when nobody in particular. */
function taskPeople(o: T.TaskOccurrence, members: T.HouseholdMember[]): string {
  const id = o.status === 'Done' ? o.doneByPublicId : o.assigneePublicId;
  const member = members.find(m => m.publicId === id);
  if (member) return o.status === 'Done' ? `feito por ${member.name}` : member.name;
  return o.status === 'Pending' ? 'quem puder' : '';
}

export function occurrenceSubtitle(o: T.TaskOccurrence, members: T.HouseholdMember[]): string {
  const parts: string[] = [];
  const who = taskPeople(o, members);
  if (who) parts.push(who);
  if (o.dueTime) parts.push(time(o.dueTime));
  if (o.alert === 'Alarm' && o.status === 'Pending') parts.push('⏰ alarme');
  if (o.checklist.length > 0) parts.push(`${o.checklist.filter(i => i.isDone).length}/${o.checklist.length} passos`);
  if (o.isOverdue) parts.push(o.windowEnd ? `era até ${dayLabel(o.windowEnd)}` : `era ${dayLabel(o.date)}`);
  else if (o.windowEnd && o.status === 'Pending') parts.push(`até ${dayLabel(o.windowEnd, false).toLowerCase()}`);
  if (o.status === 'Skipped') parts.push('dispensada');
  if (o.recurrenceType !== 'None') parts.push('↻');
  if (o.source !== 'Manual') parts.push('automática');
  return parts.join(' · ');
}

// ---------- Shopping ----------

const toPutAway = (trip: T.TripSummary) => trip.status === 'Paid' && trip.toPutAwayCount > 0;

export const tripStatusText = (trip: T.TripSummary) =>
  toPutAway(trip) ? 'por arrumar' : ({ Planned: 'planeada', InProgress: 'em curso', Paid: 'paga', Cancelled: 'cancelada' }[trip.status]);

export const tripStatusColor = (trip: T.TripSummary): 'info' | 'warning' | 'success' | 'default' =>
  toPutAway(trip) ? 'warning' : ({ Planned: 'info', InProgress: 'warning', Paid: 'success', Cancelled: 'default' } as const)[trip.status];

export const putAwayCountText = (count: number) => (count === 1 ? '1 artigo por arrumar' : `${count} artigos por arrumar`);

export function tripDetail(trip: T.TripSummary): string {
  switch (trip.status) {
    case 'InProgress': return `faltam ${trip.pendingCount} · carrinho ${money(trip.cartTotal)}`;
    case 'Paid':
      return toPutAway(trip)
        ? `${money(trip.receiptTotal ?? trip.cartTotal)} · ${putAwayCountText(trip.toPutAwayCount)}`
        : money(trip.receiptTotal ?? trip.cartTotal);
    default: return `${trip.itemCount} artigos`;
  }
}

export function needSourceChip(source: T.ShoppingNeedSource): string {
  switch (source) {
    case 'MealPlan': return 'ementa';
    case 'Carryover': return 'ficou da última vez';
    case 'Recurring': return 'habitual';
    case 'LowStock': return 'stock baixo';
    default: return '';
  }
}

/** A random GUID for client-side ids (store-mode changes). */
export function newGuid(): T.Guid {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) return (crypto as any).randomUUID();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}

const PROVIDERS: Record<T.CalendarProvider, string> = { Google: 'Google', Outlook: 'Outlook', ICloud: 'iCloud', Other: '' };

/** "há 10 min", "há 2 h", "a 3 out", as Android's CalendarFeed.Ago. */
export function ago(value: string): string {
  const minutes = (Date.now() - new Date(value).getTime()) / 60000;
  if (minutes < 1) return 'agora';
  if (minutes < 60) return `há ${Math.floor(minutes)} min`;
  if (minutes < 24 * 60) return `há ${Math.floor(minutes / 60)} h`;
  return `a ${shortDate(value.substring(0, 10))}`;
}

/** "Google · Rita · 12 eventos · lido há 10 min", as Android's CalendarFeed.Subtitle. */
export function feedSubtitle(feed: T.CalendarFeed, members: T.HouseholdMember[]): string {
  const owner = members.find(m => m.publicId === feed.ownerMemberPublicId)?.name ?? 'Partilhado';
  const parts = [PROVIDERS[feed.provider] || feed.urlHost, owner, feed.eventCount === 1 ? '1 evento' : `${feed.eventCount} eventos`];
  if (feed.busyOnly) parts.push('só ocupado');
  parts.push(feed.lastSyncedAt ? `lido ${ago(feed.lastSyncedAt)}` : 'por ler');
  return parts.filter(Boolean).join(' · ');
}

/** "15:00–17:00", "Dia todo", "Dia todo, até dom 26", as Android's CalendarEvent.TimeText. */
export function eventTime(event: T.CalendarEvent): string {
  const span = event.endDate !== event.date ? `até ${nearDay(event.endDate)}` : null;
  if (event.isAllDay) return span ? `Dia todo, ${span}` : 'Dia todo';
  return span ? `${time(event.startTime)}, ${span} às ${time(event.endTime)}` : `${time(event.startTime)}–${time(event.endTime)}`;
}

/** "Tomás e Hugo", or "Casa" when the event is everyone's. */
export function eventPeople(event: T.CalendarEvent, members: T.HouseholdMember[]): string {
  const names = members.filter(m => event.memberPublicIds.indexOf(m.publicId) >= 0).map(m => m.name);
  if (names.length === 0) return 'Casa';
  if (names.length === 1) return names[0];
  return `${names.slice(0, -1).join(', ')} e ${names[names.length - 1]}`;
}

/** The request that puts an event back as it was ("Desfazer" after deleting). */
export const eventRequest = (event: T.CalendarEvent): T.SaveCalendarEventRequest => ({
  title: event.title,
  date: event.date,
  endDate: event.endDate !== event.date ? event.endDate : null,
  startTime: event.startTime ?? null,
  endTime: event.endTime ?? null,
  location: event.location ?? null,
  notes: event.notes ?? null,
  memberPublicIds: event.memberPublicIds,
});

/** The meal as it is, to save it again with one thing changed (and to undo that change). */
export function slotRequest(slot: T.MealSlot): T.SaveMealSlotRequest {
  return {
    kind: slot.kind,
    recipePublicId: slot.kind === 'Recipe' ? slot.recipePublicId ?? null : null,
    leftoversFromSlotPublicId: slot.kind === 'Leftovers' ? slot.leftoversFromSlotPublicId ?? null : null,
    freeText: slot.kind === 'FreeText' || slot.kind === 'Out' ? slot.freeText ?? null : null,
    servingsOverride: slot.servingsOverride ?? null,
    isLocked: slot.isLocked,
    attendeePublicIds: slot.attendeePublicIds,
    sidePublicIds: slot.kind === 'Recipe' || slot.kind === 'Frozen' ? slot.sides.map(s => s.publicId) : null,
    frozenBatchPublicId: slot.kind === 'Frozen' ? slot.frozenBatchPublicId ?? null : null,
    freezeServings: slot.kind === 'Recipe' ? slot.freezeServings ?? 0 : null,
    dishes: slot.kind === 'Out' ? [] : slot.dishes.map(d => ({
      course: d.course, recipePublicId: d.recipePublicId ?? null, freeText: d.recipePublicId ? null : d.freeText ?? d.name, servings: d.servingsOverride ?? null,
    })),
    guests: slot.guests,
  };
}

/** Meals still to plan in these weeks, from tonight on, in order. */
export function freeSlotsAhead(weeks: T.WeekPlan[]): T.MealSlot[] {
  const now = today();
  return weeks.flatMap(w => w.slots)
    .filter(s => s.kind === 'Empty' && (s.date > now || (s.date === now && s.mealType === 'Dinner')))
    .sort((a, b) => (a.date === b.date ? (a.mealType === 'Lunch' ? -1 : 1) : a.date < b.date ? -1 : 1));
}

/** "Leva 3 artigos da lista.": what the server puts in a new trip to this store (not what it lacked there last time). */
export function tripTakesText(needs: T.ShoppingNeed[], storeId: T.Guid): string {
  const count = needs.filter(n => (!n.storePublicId || n.storePublicId === storeId) && n.lastUnavailableStorePublicId !== storeId).length;
  return count === 0 ? 'Não leva nada da lista (podes juntar no carrinho).'
    : count === 1 ? 'Leva 1 artigo da lista.'
    : `Leva ${count} artigos da lista.`;
}
